import { axios2 } from '@/lib/axios';
import { ApiResponse, CreateChatAPiResponse } from '@/types';

export const createChat = (chat: number): Promise<ApiResponse<CreateChatAPiResponse>> => {
  return axios2.post('/customer-api/create-converstation-customer', { chat_customer: chat });
};

export const createAgencyChat = (chat: number): Promise<ApiResponse<CreateChatAPiResponse>> => {
  return axios2.post('/customer-api/create-converstation-agency', { agency_id: chat });
};
